import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const checkExists = async (value) => {
  return await request.get(
    '/HousingStock/transport/check_exists',
    value,
    'При проверки наличия ТС в системе произошла ошибка'
  );
};

const useCheckExistQuery = (params, options = {}) =>
  useQuery(queryKeys.checkExists(params), () => checkExists(params), options);

export default useCheckExistQuery;
